export default function getApiRequestCacheKey(
  name: string,
  params: ApiRequestParams,
): string {
  const stringifiedParams = getStringifiedParams(params);
  return [name, ...stringifiedParams].join(':');
}

function getStringifiedParams(params: ApiRequestParams): string[] {
  const endParams = ['locale', 'page', 'pageSize'];

  const res = Object.entries(params)
    .sort(([aKey], [bKey]) => {
      const aIndex = endParams.indexOf(aKey);
      const bIndex = endParams.indexOf(bKey);

      const aInEnd = aIndex !== -1;
      const bInEnd = bIndex !== -1;

      if (aInEnd && bInEnd) return aIndex - bIndex;
      if (aInEnd) return 1;
      if (bInEnd) return -1;

      return aKey > bKey ? 1 : aKey < bKey ? -1 : 0;
    })
    .map(([key, value]) => `${key}-${value}`);

  return res;
}

export type ApiRequestParams = Record<
  string,
  string | string[] | number | undefined
>;
